export const shouldShowTrigger = (triggers = {}, triggerName = null) => {
  return (
    triggers[triggerName] &&
    triggers[triggerName].show &&
    !triggers[triggerName].complete
  );
};

export const isTriggerComplete = (triggers = {}, triggerName = null) => {
  return triggers[triggerName] && triggers[triggerName].complete;
};

export const getTriggerDefaults = () => ({
  complete: false,
  show: false,
});

export const getActivatedTrigger = () => ({
  complete: false,
  show: true,
});

export const getCompletedTrigger = () => ({
  complete: true,
  show: false,
});
